var _defs, _rect, _rect2, _rect3, _g, _rect4, _g2, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventPickerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "eventpicker_peach",
    cx: 0.12,
    cy: -0.12,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffba94",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ffba94",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eventpicker_rose",
    cx: 0.96,
    cy: -0.04,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa8ba",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffa8ba",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eventpicker_shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 18,
    floodColor: "#784632",
    floodOpacity: 0.14
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 228,
    fill: "#fff8f3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 228,
    fill: "url(#eventpicker_peach)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 228,
    fill: "url(#eventpicker_rose)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#eventpicker_shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 150,
    width: 600,
    height: 724,
    rx: 76,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 150,
    width: 600,
    height: 724,
    rx: 76,
    fill: "none",
    stroke: "#eed7c6",
    strokeWidth: 22
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 248,
    width: 284,
    height: 46,
    rx: 23,
    fill: "#ad4129",
    opacity: 0.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fdf1e7",
    stroke: "#e8c8b2",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 366,
    width: 440,
    height: 102,
    rx: 51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 656,
    width: 440,
    height: 102,
    rx: 51
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 511,
    width: 440,
    height: 102,
    rx: 51,
    fill: "#ef7d63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventPickerLogo);
export default __webpack_public_path__ + "static/media/event-picker-logo.a5aa536d1de3aa35e3f493d9e255dd7b.svg";
export { ForwardRef as ReactComponent };